import { CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ExtraOptions, PreloadAllModules, RouterModule } from '@angular/router';
import { FuseModule } from '@fuse';
import { FuseConfigModule } from '@fuse/services/config';
import { FuseMockApiModule } from '@fuse/lib/mock-api';
import { CoreModule } from 'app/core/core.module';
import { appConfig } from 'app/core/config/app.config';
import { mockApiServices } from 'app/mock-api';
import { LayoutModule } from 'app/layout/layout.module';
import { AppComponent } from 'app/app.component';
import { appRoutes } from 'app/app.routing';
import { NotificationService } from './shared/services/notification.service';
import { ErrorsHandler } from './shared/handlers/errorhandler';
import { ErrorService } from './shared/services/error.service';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import {MatMomentDateModule, MAT_MOMENT_DATE_ADAPTER_OPTIONS, MAT_MOMENT_DATE_FORMATS, MomentDateAdapter, provideMomentDateAdapter} from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { SharedModule } from './shared/shared.module';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { NgxMatDatetimePickerModule, NgxMatTimepickerModule } from '@angular-material-components/datetime-picker';
import { NGX_MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular-material-components/moment-adapter';
import { NgxPopperjsModule } from 'ngx-popperjs';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'
import { NgxGoogleAnalyticsModule, NgxGoogleAnalyticsRouterModule } from 'ngx-google-analytics';
import { vesselRotationReducer } from './modules/operational/lineup/store/reducers/vessel-rotation.reducer';
import { TranslateModule } from '@ngx-translate/core';
import { NgxGaugeModule } from 'ngx-gauge';
import 'ag-grid-enterprise'
import { ModuleRegistry } from "ag-grid-community";
import { initializeApp } from "firebase/app";
import { LicenseManager, EnterpriseCoreModule } from "ag-grid-enterprise";
import { environment } from 'environments/environment';

import { getAnalytics } from "firebase/analytics";

ModuleRegistry.registerModules([EnterpriseCoreModule]);
LicenseManager.setLicenseKey("[TRIAL]_this_{AG_Charts_and_AG_Grid}_Enterprise_key_{AG-087313}_is_granted_for_evaluation_only___Use_in_production_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_purchasing_a_production_key_please_contact_info@ag-grid.com___You_are_granted_a_{Single_Application}_Developer_License_for_one_application_only___All_Front-End_JavaScript_developers_working_on_the_application_would_need_to_be_licensed___This_key_will_deactivate_on_{30 June 2025}____[v3]_[0102]_MTc1MTIzODAwMDAwMA==bab99475ed6430aef766ca806f8a0647");

const app = initializeApp(environment.firebase);
//const analytics = getAnalytics(app);

const routerConfig: ExtraOptions = {
    preloadingStrategy       : PreloadAllModules,
    scrollPositionRestoration: 'enabled'
};

export const MY_FORMATS_EN_US = {
    parse: {
      dateInput: 'LL',
    },
    display: {
      dateInput: 'MM/DD/YYYY', // Adjusted to English (United States) format
      monthYearLabel: 'MMM YYYY',
      dateA11yLabel: 'LL',
      monthYearA11yLabel: 'MMMM YYYY',
    },
  };

@NgModule({
    declarations: [
        AppComponent
    ],
    imports     : [
        BrowserModule,
        BrowserAnimationsModule,
        RouterModule.forRoot(appRoutes, routerConfig),

        // Fuse, FuseConfig & FuseMockAPI
        FuseModule,
        FuseConfigModule.forRoot(appConfig),
        FuseMockApiModule.forRoot(mockApiServices),
        TranslateModule.forRoot(),
        // Core module of your application
        CoreModule,

        // Layout module of your application
        LayoutModule,

        SharedModule,
        MatSnackBarModule,
        MatMomentDateModule,
        MatAutocompleteModule,
        NgxMatTimepickerModule,
        StoreModule.forRoot({
            vesselRotation: vesselRotationReducer
          }),
          StoreModule.forFeature('rotations', vesselRotationReducer),

          StoreDevtoolsModule.instrument({maxAge: 25}), 
          FontAwesomeModule,
          NgxGoogleAnalyticsModule.forRoot('G-5VL82CGM07'),
          NgxGoogleAnalyticsRouterModule

    ],
    providers: [NotificationService,  Title, ErrorService, { provide: ErrorHandler, useClass: ErrorsHandler },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS_EN_US },
        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] }, 
        
    ],
    bootstrap   : [
        AppComponent
    ]
})
export class AppModule
{
}
